import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import { IoIosArrowDown } from "react-icons/io"
import {IoClose} from "react-icons/io5"

const Container = styled.div`
      width: ${({width})=> width};
      position: relative;
      user-select: none;

      .dropdown-btn{
        padding: 7px 10px;
        padding: 12px 10px;
        border-radius: 5px;
        height: auto;

        width: 100%;
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        background-color: ${({ theme }) => theme.mainBgColor};
        color: ${({ theme }) => theme.mainTextColor};
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};

        .btn-container{
          margin: 0 !important;
        }

      }

      .dropdown-content{
        position: absolute;
        max-height: 300px;
        overflow: auto;
        top: 110%;
        left: 0;
        color: ${({ theme }) => theme.mainTextColor};
        font-weight: var(--font-weight-md);
        background-color: ${({ theme }) => theme.mainBgColor};
        width: 100%;
        z-index: 10;
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};

        &::-webkit-scrollbar {
        width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #9e9b9b;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .dropdown-item{
          font-size: 16px;
          font-weight: var(--font-weight-md);
          line-height: 12px;
          text-align: left;
          padding: 10px;
          cursor: pointer;
          transition: all .2s;  

          &:hover{
            background-color: ${({ theme }) => theme.secondaryBgColor};
          }
        }
      }
`
const SingleInputSelect = ({name, value, options, handleChange, width,placeholder}) => {

    const [selected, setSelected] = useState()
    const {activeSelect} = useSelector(state => state.layout)

    const dispatch = useDispatch()
    const handleSelectClick = () => {
        //! bu seselct le alakalı tıklandığında select varsa ve select === bunun name ine ise sect i kapatıyor yoksa select e bunun name ini atayıp bu select i açtırıyor. 
        dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))
      }

    const handleOptionClick =(item) => {
    //! değişikliği gönderiyor
    handleChange(item.value)

    //! bu tamamen select le alakalı tıklandığında açık olan select i kapatmak için
    dispatch(handleActiveSelect(null))

    //! buradaki select i option a tıklandığında tıklanan option ı göstermek için
    setSelected(item.text)
    }

    const handleResetSelect = ()=> {
        handleChange("")
    }

  return (
    <Container className="dropdown" onClick={(e) => e.stopPropagation()} width={width}>
      <div className="dropdown-btn" onClick={handleSelectClick}>{value || placeholder}<div className="btn-container">{(value && name !== "isGonderilmis") && <IoClose onClick={handleResetSelect}/>} <IoIosArrowDown/></div></div>
      {(activeSelect === name)  &&
        <div className="dropdown-content">
          {
            options.map((item, i)=>(
              <div key={i} onClick={() => handleOptionClick(item)} className="dropdown-item">{item.value}</div>
            ))
          }
        </div>
      }
      </Container>
  )
}

export default SingleInputSelect